<ul [class.work-ui-progress-steps--vertical]="alignment() === 'vertical'" class="work-ui-progress-steps">
  @for (step of steps(); track step; let i = $index) {
    <li [class.work-ui-progress-steps__step--active]="i === activeStep()"
        [class.work-ui-progress-steps__step--completed]="step.completed"
        class="work-ui-progress-steps__step">
      <p class="work-ui-progress-steps__step-icon"><b>{{ i + 1 }}</b></p>
      <p class="work-ui-progress-steps__step-text work-text-overflow-ellipsis"><b>{{ step.label | translate }}</b></p>
    </li>
  }
</ul>
